/**
 * Sets the modified flag of every code name that `state` names, in every folder that lists it (a map is listed in each folder that holds it).
 * `state` is the `affectedMapsState` that a map or axis save, or an undo (and so a per-map reset), answers with. A code name it does not name
 * keeps its flag, and a name that is not in the listing is ignored. Like its siblings it changes the folder structure it is given and returns it.
 * @param state {[mapName]: boolean}
 * @param folderStructure
 * @returns [obj]
 */
export const setMapsModified = (state, folderStructure) => {
    const flags = new Map(Object.entries(state));

    folderStructure.forEach((folder) => {
        folder.codeNames.forEach((map) => {
            if(flags.has(map.id)) map.swModified = flags.get(map.id);
        })
    });

    return folderStructure;
};

/**
 * Sets the star of every code name of the map, in every folder that lists it, to what the API answered. It is not a toggle: the answer is the state.
 * A name that is not in the listing is ignored. Like its siblings it changes the folder structure it is given and returns it.
 * @param {string} mapId
 * @param {boolean} favourited
 * @param folderStructure
 * @returns [obj]
 */
export const setMapFavourited = (mapId, favourited, folderStructure) => {
    folderStructure.forEach((folder) => {
        folder.codeNames.forEach((map) => {
            if(map.id === mapId) map.favourited = favourited;
        })
    });

    return folderStructure;
};
